
import Assert from './assert';

/*

关注点，是不是微信，是不是ios 是不是安卓，是不是小程序，是不是自己的app
*/
const envItems = ['weixin','ios','android','mapp','selfApp'];

/**
 * 判断是不是微信。
 * 
*/
const isWeixin = () => {
    //判断是否微信登陆
    var ua = window.navigator.userAgent.toLowerCase();
        console.debug(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}


/**
 * 返回容器类型
 *
*/
const showContainerType = ()=> {
    // TODO 算出是什么浏览器   ios  android  weixin
    
    let weixin = isWeixin();

    return weixin ? 'weixin' : "";
}

const  specialFan = () =>{
    let containerType = showContainerType();
    const specialFans = {
        ios: {
            // 容器特殊的方法写这里。
        },
        android: {
            // 容器特殊的方法写这里。
        },
        weixin: {
            // 容器特殊的方法写这里。
        }
    };
    return (containerType && specialFans[containerType]) || {};
}



/**
 * 默认的方法
 *
*/
const defaultFan = {
    localSave: function(key,val) {
        if(key==='token')console.log('检查到保存token:%s',val);
        localStorage.setItem(key,val);
    },
    localGet: function(key) {
        return localStorage.getItem(key);
    },

    localRemove: function(key) {
        localStorage.removeItem(key);
    },
    feature:(item)=>{
        Assert.status(envItems.filter(envItem=>item===envItem).length==1,'不允许写不存在的纬度');
        switch(item){
            case 'weixin':return isWeixin();
            default:
            throw `暂不支持判断:${item}`;
        }
    }

};

const intensifyFun = {
    localGetOrSave:(key,orSave)=>{
        let val = this.localGet(key)
        if( val ===undefined ){
            this.localSave(orSave);
            return orSave;
        }else{
            return val;
        }
    }
}


/**
 * 如果是特殊的浏览器，会用特浏览器覆盖这个方法。
 * 
*/
const containerFan =  {...intensifyFun,...defaultFan, ...specialFan()} ;

export default containerFan;



// WEBPACK FOOTER //
// ./src/utils/container.js